import React from 'react'
import Header from '../components/header/Header'
import Itinerary from '../assets/itinerary-big.jpg'
import Footer from '../components/footer/Footer'
import Contact from '../components/contact/Contact'
import Description from '../components/description/description'
import { BiCheck } from 'react-icons/bi'
import TitleText from '../utils/TitleText'
import HomeButton from '../components/homebutton/HomeButton'

const ItineraryMin = () => {
    const footitems=[
        {sec:'#',title:'Home'},
        {sec:'#description',title:'Description'},
        {sec:'#contact',title:'Contact'},

    ]
    TitleText('Itinerary Cost Minimization')
  return (
    <>
        <HomeButton/>
        <Header text1="" text2="Itinerary Cost Minimization" text3="" img={Itinerary} />
        <Description title= 'Desciption' link ='https://github.com/Anmol23oct/Itineary-Cost-Minimization' data={
            <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>A* algorithm put into practice and evaluated its performance in comparison to Dijkstra's algorithm.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>The information was obtained from the U.S. Bureau of Transportation Statistics as a.csv file.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>The graph space was reduced to 59,241 edges across 429 vertices by taking the average price between each airport in order to make the data more understandable.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Tech Stack: Python, Spider, Matplotlib.</p>
            </li>
    
          </ul>
        }/>
        <Contact/>
        <Footer footitems={footitems}/>
    </>
  )
}

export default ItineraryMin